import React from "react";
import { Text, Group } from "@mantine/core";

export default function SelectItem({ label, description, ...others }) {
  return (
    <div {...others}>
      <Group noWrap>
        <div>
          <Text size="sm">{label}</Text>
          <Text size="xs" color="dimmed">
            {description}
          </Text>
        </div>
      </Group>
    </div>
  );
}